module.exports = __webpack_public_path__ + "img/img_nav_bank-w.6ecab10c.svg";